interface Props {
  amountCents: number;
  saleCents?: number;
  className?: string;
}

export function formatPrice(cents: number): string {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

export default function Price({ amountCents, saleCents, className = '' }: Props) {
  // text-ink: native <button> ancestors reset color to the UA default, so the
  // price must carry its own themed color rather than rely on inheritance.
  // whitespace-nowrap: un montant et son « € » sont un seul mot. Dans une ligne
  // `flex justify-between`, un nom de plat long serre la colonne du prix jusqu'a
  // renvoyer le symbole seul a la ligne suivante — SC-959, panneau « Ma table ».
  // Pose sur chaque montant, pas sur la paire promo : celle-ci garde le droit de
  // passer a la ligne entre le prix barre et le prix soldé.
  if (saleCents !== undefined && saleCents < amountCents) {
    return (
      <span className={`font-mono font-bold text-ink ${className}`}>
        <span className="text-hot-pink whitespace-nowrap">{formatPrice(saleCents)}</span>
        <span className="text-[var(--ink-faint)] line-through ml-2 whitespace-nowrap">
          {formatPrice(amountCents)}
        </span>
      </span>
    );
  }
  return (
    <span className={`font-mono font-bold text-ink whitespace-nowrap ${className}`}>
      {formatPrice(amountCents)}
    </span>
  );
}
